import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Link = ({
  className,
  color = '#00304D',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M6.84352 17.1565c-1.20915-1.2091-1.20915-3.1749 0-4.384l2.25737-2.2574-1.3435-1.34352-2.25737 2.25732c-1.95162 1.9517-1.95162 5.1195 0 7.0711 1.95161 1.9516 5.11948 1.9516 7.07108 0l2.2574-2.2574-1.3435-1.3435-2.2574 2.2574c-1.2092 1.2092-3.17493 1.2092-4.38408 0Zm3.03519-1.621 5.65689-5.65681-1.4143-1.41422-5.65681 5.65683 1.41422 1.4142ZM11.4289 5.49998 9.1716 7.75736l1.3435 1.34351 2.2573-2.25739c1.2092-1.20915 3.1749-1.20915 4.3841 0 1.2092 1.20916 1.2092 3.17492 0 4.38402l-2.2573 2.2574 1.3435 1.3435L18.5 12.5711c1.9516-1.9517 1.9516-5.1195 0-7.07112-1.9516-1.95161-5.1195-1.95161-7.0711 0Z"
        fill={color}
      />
    </svg>
  );
};
